import debounce from "lodash.debounce";
import { forwardRef, memo, useCallback, useMemo, useState } from "react";

const sharedInputClass =
  "portal-input block h-11 w-full px-4 py-2 transition-all duration-200";

const InputSearch = memo(
  forwardRef(({ searchValue, setSearchValue, setPageNumber }, ref ) => {
    const [keyWord, setKeyWord] = useState(searchValue || "");

    const debouncedSearchTermCallback = useMemo(
      () =>
        debounce((value) => {
          setSearchValue(value);
          setPageNumber(1);
        }, 600),
      [setPageNumber, setSearchValue]
    );

    const handleSearchChange = useCallback(
      (event) => {
        const value = event.target.value;
        setKeyWord(value);
        debouncedSearchTermCallback(value);
      },
      [debouncedSearchTermCallback]
    );

    return (
      <div className="relative">
        <label
          htmlFor="search"
          className="mb-2 block text-sm font-semibold"
          style={{ color: "var(--layout-text)" }}
        >
          البحث
        </label>
        <input
          ref={ref}
          id="search"
          type="search"
          className={sharedInputClass}
          value={keyWord}
          placeholder="البحث"
          autoComplete="off"
          onChange={handleSearchChange}
        />
      </div>
    );
  })
);

const SelectInput = ({ value, setValue, options, setPageNumber }) => {
  return (
    <div className="relative">
      <label
        htmlFor="status"
        className="mb-2 block text-sm font-semibold"
        style={{ color: "var(--layout-text)" }}
      >
        الحالة
      </label>
      <select
        id="status"
        className={sharedInputClass}
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
          setPageNumber(1);
        }}
      >
        <option value="">حدد الحالة</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};

const DateInput = memo(({ title, value, setValue, setPageNumber }) => {
  const [keyWord, setKeyWord] = useState(value || "");

  const debouncedSearchTermCallback = useMemo(
    () =>
      debounce((nextValue) => {
        setValue(nextValue);
        setPageNumber(1);
      }, 600),
    [setPageNumber, setValue]
  );

  const handleSearchChange = useCallback(
    (event) => {
      const nextValue = event.target.value;
      setKeyWord(nextValue);
      debouncedSearchTermCallback(nextValue);
    },
    [debouncedSearchTermCallback]
  );

  return (
    <div className="relative">
      <label
        className="mb-2 block text-sm font-semibold"
        style={{ color: "var(--layout-text)" }}
      >
        {title}
      </label>
      <input
        type="date"
        className={sharedInputClass}
        value={keyWord}
        onChange={handleSearchChange}
      />
    </div>
  );
});

export default InputSearch;
export { DateInput, SelectInput };
